import { Modal, Pagination } from 'antd';
import moment from 'moment';
import React from 'react';
import { encryption } from 'utils';
import type { IMenuStockDetailModalProps } from './types';

const DETAIL_MODAL_HEADERS = [
  { label: '메뉴명', width: '25%' },
  { label: '재고수량', width: '25%' },
  { label: '판매량', width: '25%' },
  { label: '남은 재고수량', width: '25%' }
] as const;

const PAYMENT_DETAIL_HEADERS = [
  { label: '결제번호', width: '25%' },
  { label: '결제일시', width: '25%' },
  { label: '주문자', width: '25%' },
  { label: '수량', width: '25%' }
] as const;

const BODY_CELL_STYLES = {
  padding: '10px',
  border: '1px solid #ddd'
} as const;

export const TABLE_STYLES = {
  width: '100%',
  borderCollapse: 'collapse'
} as const;

export const ROW_STYLES = {
  width: '100%'
} as const;

const TABLE_ROW_STYLES = {
  ...ROW_STYLES,
  fontWeight: '700'
} as const;

const PAGINATION_STYLES = {
  textAlign: 'center' as const,
  padding: '20px 0',
  borderTop: '1px solid #f0f0f0'
};

export const TableHeaderCell: React.FC<{ label: string; width: string }> = ({ label, width }) => (
  <td className="menu-status-box" style={{ width }}>
    <span className="font-size-18px font-color-white">{label}</span>
  </td>
);

const TableBodyCell: React.FC<{ label: string; width: string }> = ({ label, width }) => (
  <td style={{ width, ...BODY_CELL_STYLES }}>
    <div>{label}</div>
  </td>
);

const MenuStockDetailModal = ({
  open,
  onClose,
  menuDetailModalData,
  pageParams,
  onPageParamsChange
}: IMenuStockDetailModalProps) => {
  const currentPage = pageParams.page;
  const pageSize = pageParams.size;

  const handlePageChange = (page: number) => {
    onPageParamsChange({ ...pageParams, page });
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={
        <button type="button" className="btn btn-success" onClick={onClose}>
          닫기
        </button>
      }
      width={1000}
      title="판매상세"
      closable
      maskClosable={false}
      centered
    >
      {menuDetailModalData ? (
        <div>
          <table style={TABLE_STYLES}>
            <thead>
              <tr className="menu-table-header" style={ROW_STYLES}>
                {DETAIL_MODAL_HEADERS.map(({ label, width }) => (
                  <TableHeaderCell key={label} label={label} width={width} />
                ))}
              </tr>
            </thead>
          </table>

          <table style={{ ...TABLE_STYLES, fontSize: '16px', textAlign: 'center' }}>
            <tbody>
              <tr style={ROW_STYLES}>
                <TableBodyCell key="메뉴명" label={menuDetailModalData.menuName} width="25%" />
                <TableBodyCell
                  key="재고수량"
                  label={
                    menuDetailModalData.stock !== null && menuDetailModalData.stock !== undefined
                      ? encryption(menuDetailModalData.stock)
                      : '-'
                  }
                  width="25%"
                />
                <TableBodyCell
                  key="판매량"
                  label={
                    menuDetailModalData.sales !== null && menuDetailModalData.sales !== undefined
                      ? encryption(menuDetailModalData.sales)
                      : '-'
                  }
                  width="25%"
                />
                <TableBodyCell
                  key="남은 재고수량"
                  label={
                    menuDetailModalData.remainingStock !== null && menuDetailModalData.remainingStock !== undefined
                      ? encryption(menuDetailModalData.remainingStock)
                      : '-'
                  }
                  width="25%"
                />
              </tr>
            </tbody>
          </table>

          <div style={{ margin: '30px 0', fontSize: '14px' }}>* 결제번호 복사 후 실시간 매출 메뉴에서 조회 가능합니다.</div>

          <table
            style={{
              ...TABLE_STYLES,
              fontSize: '16px',
              textAlign: 'center',
              height: '45px'
            }}
          >
            <thead>
              <tr style={TABLE_ROW_STYLES}>
                {PAYMENT_DETAIL_HEADERS.map(({ label, width }) => (
                  <td key={label} style={{ width, ...BODY_CELL_STYLES }}>
                    {label}
                  </td>
                ))}
              </tr>
            </thead>
          </table>

          <div
            style={{
              maxHeight: '500px',
              overflowY: 'auto',
              border: '1px solid #ddd',
              borderTop: 'none'
            }}
          >
            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',
                fontSize: '16px',
                textAlign: 'center'
              }}
            >
              <tbody>
                {menuDetailModalData &&
                  menuDetailModalData.content &&
                  menuDetailModalData.content.map((item) => {
                    return (
                      <tr key={`${item.payRoomIdx}`} style={ROW_STYLES}>
                        <td style={{ width: '25%', ...BODY_CELL_STYLES }}>{item.payRoomIdx}</td>
                        <td style={{ width: '25%', ...BODY_CELL_STYLES }}>
                          {moment(item.useDate).format('YYYY-MM-DD HH:mm:ss')}
                        </td>
                        <td style={{ width: '25%', ...BODY_CELL_STYLES }}>{item.userName}</td>
                        <td style={{ width: '25%', ...BODY_CELL_STYLES }}>{item.quantity}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>

            {menuDetailModalData && menuDetailModalData.totalCount ? (
              <div style={PAGINATION_STYLES}>
                <Pagination
                  current={currentPage}
                  pageSize={pageSize}
                  total={menuDetailModalData.totalCount}
                  onChange={handlePageChange}
                  showQuickJumper={false}
                  showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
                />
              </div>
            ) : (
              <div style={PAGINATION_STYLES}>
                <div style={{ textAlign: 'center', color: '#666', padding: '20px' }}>
                  {!menuDetailModalData.totalCount ? <div>상세 데이터가 존재하지 않습니다.</div> : null}
                </div>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div>상세 데이터가 존재하지 않습니다.</div>
      )}
    </Modal>
  );
};

export default MenuStockDetailModal;
